export default "__VITE_ASSET__CfTeK81S__"